// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { ApiKeyAuth, OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgeIntakeApi = class EdgeIntakeApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'ApiKey': new ApiKeyAuth('header', 'x-apikey'),
            'trialcard-poc.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'trialcard-test.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Bearer': new ApiKeyAuth('header', 'Authorization'),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param hcpIntakeRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async intakeHcpIntake(hcpIntakeRequestModel, xProgramId) {
        const _url_ = '/edge/intake/HcpIntake';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'hcpIntakeRequestModel' is not null or undefined
        if (hcpIntakeRequestModel === null || hcpIntakeRequestModel === undefined) {
            throw new Error('Required parameter hcpIntakeRequestModel was null or undefined when calling intakeHcpIntake.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(hcpIntakeRequestModel, "HcpIntakeRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "IntakeHcpIntakeDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param isHcpIntakeAllowedRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async intakeIsHcpIntakeAllowed(isHcpIntakeAllowedRequestModel, xProgramId) {
        const _url_ = '/edge/intake/IsHcpIntakeAllowed';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'isHcpIntakeAllowedRequestModel' is not null or undefined
        if (isHcpIntakeAllowedRequestModel === null || isHcpIntakeAllowedRequestModel === undefined) {
            throw new Error('Required parameter isHcpIntakeAllowedRequestModel was null or undefined when calling intakeIsHcpIntakeAllowed.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(isHcpIntakeAllowedRequestModel, "IsHcpIntakeAllowedRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "IntakeIsHcpIntakeAllowedDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param patientIntakeRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async intakePatientIntake(patientIntakeRequestModel, xProgramId) {
        const _url_ = '/edge/intake/PatientIntake';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'patientIntakeRequestModel' is not null or undefined
        if (patientIntakeRequestModel === null || patientIntakeRequestModel === undefined) {
            throw new Error('Required parameter patientIntakeRequestModel was null or undefined when calling intakePatientIntake.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(patientIntakeRequestModel, "PatientIntakeRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "IntakePatientIntakeDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param simpleIntakeRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async intakeSimpleIntake(simpleIntakeRequestModel, xProgramId) {
        const _url_ = '/edge/intake/SimpleIntake';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'simpleIntakeRequestModel' is not null or undefined
        if (simpleIntakeRequestModel === null || simpleIntakeRequestModel === undefined) {
            throw new Error('Required parameter simpleIntakeRequestModel was null or undefined when calling intakeSimpleIntake.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(simpleIntakeRequestModel, "SimpleIntakeRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "IntakeSimpleIntakeDefaultResponse");
        }
        return response;
    }
};
EdgeIntakeApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgeIntakeApi);
export { EdgeIntakeApi };
//# sourceMappingURL=edgeIntakeApi.js.map